import * as types from './constants';

const initialState = {
  purpose: '',
  type: '',
  code: null
};

const actions = {
  // Duplicate Code Context
  [types.SET_MANAGE_CODE]: (state, { payload }) => {

    const data = {
      ...state,
      purpose: payload.purpose || '',
      type: payload.type || '',
      code: payload.code
    };

    return { ...data };
  },

  [types.RESET_MANAGE_CODE]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};